import { render, staticRenderFns } from "./groupFriend.vue?vue&type=template&id=05d4f4f9&scoped=true&"
import script from "./groupFriend.vue?vue&type=script&lang=js&"
export * from "./groupFriend.vue?vue&type=script&lang=js&"
import style0 from "./groupFriend.vue?vue&type=style&index=0&id=05d4f4f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4f4f9",
  null
  
)

export default component.exports